import { render, staticRenderFns } from "./PurchasePlanPreview.vue?vue&type=template&id=5d52c39d&scoped=true&"
import script from "./PurchasePlanPreview.vue?vue&type=script&lang=js&"
export * from "./PurchasePlanPreview.vue?vue&type=script&lang=js&"
import style0 from "./PurchasePlanPreview.vue?vue&type=style&index=0&id=5d52c39d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d52c39d",
  null
  
)

export default component.exports